import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import AnimatedIcon from './AnimatedIcon.jsx';
import Navigation from './Navigation.jsx';
import FloatingControls from './FloatingControls.jsx';
import IntroAnimation from './IntroAnimation.jsx';
import { useState, useEffect, useRef } from 'react';

const Header = ({ theme, setTheme, accessibility, setAccessibility, onIntroComplete = null }) => {
  const [titleSettled, setTitleSettled] = useState(false);
  const [titleStatic, setTitleStatic] = useState(false);
  const [logoSettled, setLogoSettled] = useState(false);
  const titleTimeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (titleTimeoutRef.current) {
        clearTimeout(titleTimeoutRef.current);
        titleTimeoutRef.current = null;
      }
    };
  }, []);

  return (
    <>
      <header className="site-header">
        {/* Logo swoop (icon) then title, then navigation, accessibility, theme, CTA in precise staggered order */}
        {/* Navigation sits on the left (animated from left but placed before logo in DOM so it ends up on the left) */}
        <IntroAnimation delay={340} direction="left">
          <Navigation />
        </IntroAnimation>

        {/**
         * We want a strict domino effect: title animates first and when it completes
         * the logo starts. Use state to chain via onRest.
         */}
        <Link to="/" className={`logo ${logoSettled ? 'settled' : ''}`} aria-label="TapptiQ home">
          {/* Title: reserve layout space and absolutely-position the animated title
              so when we replace it with the static text there is no position shift
          <span className="logo-text-container" style={{ display: 'inline-flex', position: 'static', alignItems: 'right', justifyContent: 'right', verticalAlign: 'middle' }}>
          {/* {!titleStatic && (*/
              <IntroAnimation
                className="logo-title"
                delay={0}
                direction="right"
                scaleFrom={1}
                //springConfig={{ mass: 1, tension: 152, friction: 24, precision: 0.01 }}
                // absolutely position the animated wrapper so transforms don't affect flow
               // style={{ position: 'absolute', display: 'block', alignItems: 'left', justifyContent: 'left' }}
                onRest={() => {
                  if (titleTimeoutRef.current) clearTimeout(titleTimeoutRef.current);
                  titleTimeoutRef.current = setTimeout(() => {
                    setTitleStatic(true);
                    setTitleSettled(true);
                  }, 100);
                }}
              >
                <div className="logo-text"// style={{alignItems: 'center', justifyContent: 'center' 
                // // verticalAlign:'top' , position: 'static', display: 'block', 
                // }}
                >
                   TAPPT<span className="logo-span">iQ</span>
                </div>
              </IntroAnimation>
            /* )} */}

            {/* static text sits in the same container; hidden until the animated intro finishes */}
           {/* titleSettled && ( */}
         {/*  <div className="logo-text" aria-hidden={!titleStatic} style={{ visibility: titleStatic ? 'visible' : 'hidden',// to: { x: 5, y: 0, s: 1.5 }, verticalAlign:'top' , position: 'static', display: 'block',
            // alignItems: 'center', justifyContent: 'center'S
           }}>
              TAPPT<span className="logo-span">iQ</span>
            </div>

            {/* )} */}
          {/*</span>*/}

          {/* Render logo only after title animation has settled so it starts after title finishes.
              Replace the animated wrapper with a static SVG once the logo finishes to stop
              any remaining wrapper-based animation. 
          {titleSettled && !logoSettled && (*/}
            <IntroAnimation
              className="logo-icon"
              delay={0}
              direction="left"
              friction={0}
              scaleFrom={2}
              style={{ alignItems: 'right' }}
              onRest={() => {
                // mark local settled state so the animated wrapper is replaced
                // with the static logo immediately. Wait 100ms before notifying
                // the parent that the intro is complete so the logo has a
                // brief pause before resuming normal site rendering.
                setLogoSettled(true);
                setTimeout(() => {
                  if (typeof onIntroComplete === 'function') onIntroComplete();
                }, 10);
              }}
            >
              <AnimatedIcon name="logo" />
            </IntroAnimation>
          {/*})}

          {logoSettled && (
            <span className="logo-icon logo-icon-static" aria-hidden="true">
              <AnimatedIcon name="logo" />
            </span>
          )*/}
        </Link>
     <FloatingControls
          theme={theme}
          setTheme={setTheme}
          accessibility={accessibility}
          setAccessibility={setAccessibility}
        />

      </header>
      
      {/* Floating controls are positioned in place, but their internal buttons are staggered */}
       <div>
       
      </div>
    </>
  );
};

Header.propTypes = {
  theme: PropTypes.string.isRequired,
  setTheme: PropTypes.func.isRequired,
  accessibility: PropTypes.shape({
    textSize: PropTypes.string,
    highContrast: PropTypes.bool,
    reduceMotion: PropTypes.bool,
  }).isRequired,
  setAccessibility: PropTypes.func.isRequired,
  onIntroComplete: PropTypes.func,
};

export default Header;
